module.exports = __webpack_public_path__ + "static/media/brilliwhite-3.ebd3dbfb.png";